import RingbaAccountsAPI from '@/api/ringba-accounts.api'

const state = {
  accounts: []
}

/** 
 * @type {import('vuex').GetterTree<typeof state>} 
 */
const getters = {}

/** 
 * @type {import('vuex').ActionTree<typeof state>} 
 */
const actions = {
  async fetchAccounts({ commit }, { accountId }) {
    const response = await RingbaAccountsAPI.listAccounts(accountId)
    commit('SET_ACCOUNTS', response.data)
    return response
  }
}

/** 
 * @type {import('vuex').MutationTree<typeof state>} 
 */
const mutations = {
  SET_ACCOUNTS(state, accounts) {
    state.accounts = accounts
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}